import React from 'react';
import SidePanelLayout from "layouts/SidePanelLayout";
import ClearingSystemPanel from "./ClearingSystemPanel";
import ClearingSystemFilter from "./ClearingSystemFilter";
import {ClearingSystemContextProvider} from "./context";

export default function ClearingSystem({startOnCreate = false}) {

    return (<>
        <ClearingSystemContextProvider startOnCreate={startOnCreate}>
            <SidePanelLayout
                sideComponent={ClearingSystemFilter}
                mainComponent={ClearingSystemPanel}>
            </SidePanelLayout>
        </ClearingSystemContextProvider>
    </>);

}

